module.exports = __webpack_public_path__ + "img/zh.23a4f068.svg";